/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RegisterDeviceRequestBody = {
  /**
   * The device's hostname, shown to administrators. Self-reported.
   */
  hostname?: string | undefined;
  /**
   * The join token from createDeviceJoinToken.
   */
  joinToken: string;
  /**
   * The device's public signing key as a JWK: EC P-256 (ES256) or OKP Ed25519 (EdDSA). Private key material is refused.
   */
  publicJwk: { [k: string]: any };
  /**
   * The device's serial number, shown to administrators. Self-reported.
   */
  serial?: string | undefined;
};

/** @internal */
export type RegisterDeviceRequestBody$Outbound = {
  hostname?: string | undefined;
  join_token: string;
  public_jwk: { [k: string]: any };
  serial?: string | undefined;
};

/** @internal */
export const RegisterDeviceRequestBody$outboundSchema: z.ZodMiniType<
  RegisterDeviceRequestBody$Outbound,
  RegisterDeviceRequestBody
> = z.pipe(
  z.object({
    hostname: z.optional(z.string()),
    joinToken: z.string(),
    publicJwk: z.record(z.string(), z.any()),
    serial: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      joinToken: "join_token",
      publicJwk: "public_jwk",
    });
  }),
);

export function registerDeviceRequestBodyToJSON(
  registerDeviceRequestBody: RegisterDeviceRequestBody,
): string {
  return JSON.stringify(
    RegisterDeviceRequestBody$outboundSchema.parse(registerDeviceRequestBody),
  );
}
